'use client';

import useLogEvents from '@/lib/client-hook/use-log-events';
import React from 'react';
import { Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/scrollbar';
import { ShopMission } from '@/schema/shop';
import classes from './promotion-slide.module.scss';
import { convertLanguageName } from '@/lib/convert-language-code';
import { Languages } from '@/lib/dictionaries';
import Image from 'next/image';

function PromotionSlide({
  lang,
  missions,
  soldCount,
  isQuantityDisabled,
}: {
  lang: Languages;
  missions: ShopMission[];
  soldCount: number;
  isQuantityDisabled: boolean;
}) {
  const { logShareEvent } = useLogEvents();
  const handleClick = (mission: ShopMission) => {
    logShareEvent('bnb_shop_detail_event', {
      title: mission.partner.title[convertLanguageName(lang)],
      language: lang,
    });
  };

  return (
    <div className={classes.promotionItemList}>
      <div className={classes.swiperGroupBox}>
        <div className={classes.swiperScrollbar}></div>
        <Swiper
          spaceBetween={16}
          slidesPerView="auto"
          observeParents={true}
          observer={true}
          scrollbar={{
            hide: false,
            draggable: true,
          }}
          modules={[Scrollbar]}
          className={classes.swiper}
        >
          {missions.map((mission, index) => (
            <SwiperSlide
              key={`mission-${mission.partner.id}-${index}`}
              virtualIndex={index}
              className={classes.swiperSlide}
              role="button"
              onClick={() => handleClick(mission)}
            >
              <div className={classes.partBox}>Part {mission.number}</div>
              <div
                className={`${classes.promotionItem} ${soldCount >= mission.section ? classes.typeEnd : undefined}`}
              >
                <div className={classes.imgBox}>
                  <Image
                    src={mission.partner.thumbnailUrl}
                    width={mission.partner.thumbnailInfo.width}
                    height={mission.partner.thumbnailInfo.height}
                    alt={mission.partner.title[convertLanguageName(lang)]}
                  />
                </div>
                <div className={classes.infoBox}>
                  <div>
                    <div className={classes.subjectBox}>
                      {mission.partner.title[convertLanguageName(lang)]}
                    </div>

                    <div className={`${classes.percentBox} ${classes.fcRed}`}>
                      {Math.floor((soldCount / mission.section) * 100) >= 100
                        ? 100
                        : Math.floor((soldCount / mission.section) * 100)}
                      <span>%</span>
                    </div>
                  </div>
                  {!isQuantityDisabled && (
                    <div className={classes.cntBox}>
                      <span className={classes.soldCnt}>
                        {soldCount >= mission.section
                          ? mission.section
                          : soldCount}
                      </span>
                      /{mission.section}
                    </div>
                  )}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default PromotionSlide;
